// Kirk Orthodontics (Dr. Blair A. Kirk; Petaluma CA) - single office. Backend:
// bondLocations.ts KIRK_PETALUMA (brandId "kirk", catalog b43d1ccd, Edge loc 2,
// procedure 216, DB 331). Native booking via ortho2-newpatient backend (WCF intake
// disabled). English-only (Dr. Kirk habla Espanol, but no Spanish site version).
import type { BrandConfig } from "./types";

export const kirk: BrandConfig = {
  slug: "kirk",
  brandId: "kirk",
  brandName: "Kirk Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/95709291-5638-46fd-8423-60d82e23b48c.png",
  phone: "(707) 762-8047",
  phoneHref: "tel:+17077628047",
  theme: { primary: "#EA61AA", primaryDark: "#B23C7E" }, // scoured 2026-07-20 smilesbykirk.com (pink)
  locales: ["en"],
  locations: {
    KIRK_PETALUMA: {
      id: "KIRK_PETALUMA",
      name: "Petaluma",
      addressLines: ["3835 Cypress Dr, Suite 208", "Petaluma, CA 94954"],
      mapsUrl: "https://maps.google.com/?q=3835+Cypress+Dr+Suite+208+Petaluma+CA+94954",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { PETALUMA: "KIRK_PETALUMA", KIRK: "KIRK_PETALUMA" },
};
